"use client";

import { c as _c } from "react/compiler-runtime";
import { Mail, MapPin, Phone } from "lucide-react";
import { useTranslations } from "next-intl";
import React from "react";
type ContactInfoCardProps = {
  icon: React.ReactNode;
  label: string;
  value: string;
  href?: string;
};
function ContactInfoCard(t0) {
  const $ = _c(17);
  const {
    icon,
    label,
    value,
    href
  } = t0;
  const t1 = href ? "w-14 h-14 rounded-full bg-terracotta/20 flex items-center justify-center mb-4 transition-colors group-hover:bg-terracotta/30" : "w-14 h-14 rounded-full bg-terracotta/20 flex items-center justify-center mb-4 transition-colors";
  let t2;
  if ($[0] !== icon || $[1] !== t1) {
    t2 = <div className={t1}>{icon}</div>;
    $[0] = icon;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <p className="text-wood-natural text-sm mb-1">{label}</p>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = href ? "text-lg font-medium text-forest-green group-hover:text-terracotta transition-colors" : "text-lg font-medium text-forest-green";
  let t5;
  if ($[5] !== t4 || $[6] !== value) {
    t5 = <p className={t4}>{value}</p>;
    $[5] = t4;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t5) {
    t6 = <>{t2}{t3}{t5}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const content = t6;
  if (href) {
    let t7;
    if ($[12] !== content || $[13] !== href) {
      t7 = <a href={href} className="group flex flex-col items-center text-center p-6 rounded-2xl bg-white-cream/50 hover:bg-white-cream transition-colors">{content}</a>;
      $[12] = content;
      $[13] = href;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  let t7;
  if ($[15] !== content) {
    t7 = <div className="flex flex-col items-center text-center p-6 rounded-2xl bg-white-cream/50">{content}</div>;
    $[15] = content;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export function ContactInfoCards() {
  const $ = _c(22);
  const t = useTranslations("contact");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Phone className="w-6 h-6 text-terracotta" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("info.phone");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <ContactInfoCard icon={t0} label={t1} value="+33 7 43 60 04 12" href="tel:+33743600412" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Mail className="w-6 h-6 text-terracotta" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("info.email");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <ContactInfoCard icon={t3} label={t4} value="contact@amo-r.eu" href="mailto:contact@amo-r.eu" />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MapPin className="w-6 h-6 text-terracotta" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("info.zone");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("info.zoneValue");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <ContactInfoCard icon={t6} label={t7} value={t8} />;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t9) {
    t10 = <div className="grid md:grid-cols-3 gap-8 w-full">{t2}{t5}{t9}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}